import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

interface ISearchableMultiSelectModalProps {
    title: string,
    text?: string,
    options: string[],
    currentSelection: string[],
    onSelect: (value: string[]) => void
    searchable?: boolean,
    isAgentName?: boolean,
    activeAgentFlagHandler?: (boolean) => void,
    isSentiment?: boolean,
    isAgent?: boolean;
}

export default function SearchableMultiSelectModal(props: ISearchableMultiSelectModalProps) {
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    const [chosen, setChosen] = useState<string[] | undefined>(props.currentSelection);
    const [activeAgentsFlag, setActiveAgentsFlag] = useState<boolean>(false);
    const [disableSelections, setDisableSelections] = useState<boolean>(false);

    useEffect(() => {
        if (props.isSentiment && selectedOptions.length >= 2) {
            setDisableSelections(true);
        }
        if (props.isSentiment && selectedOptions.length < 2) {
            setDisableSelections(false);
        }
    }, [selectedOptions])

    useEffect(() => {
        setSelectedOptions(props.currentSelection);
    }, [props.currentSelection])

    useEffect(() => {
        if (props.activeAgentFlagHandler != undefined) {
            props.activeAgentFlagHandler(activeAgentsFlag);
        }
    }, [activeAgentsFlag])

    let label = props.title;
    if (props.searchable === true) {
        if (chosen === null) {
            label = ' is: Any';
        }
        else if (chosen === undefined || chosen.length === 0) {
            label = ' is: Any';
        }
        else {
            label = '';
            chosen.map((value, index) => {
                if (index !== 0) {
                    label += ', '
                }
                label += value;
            });;
        }
    }

    const HandleConfirm = () => {
        setChosen(selectedOptions);
        props.onSelect(selectedOptions);
        Close();
    }

    const HandleSelect = (value: string[]) => {
        setSelectedOptions([...value]);
    }

    const Open = () => {
        setOpen(true);
        setSelectedOptions(props.currentSelection);
    }

    const Close = () => {
        setOpen(false);
    }

    const activeAgentCheckboxHandler = () => {
        setActiveAgentsFlag(flag => !flag);
    }

    return (
        <Grid>
            <Chip
                label={label}
                clickable={!props.isAgent}
                onClick={props.isAgent ? () => { } : Open}
            />
            <Dialog
                open={open}
                onClose={Close}
                maxWidth="lg" fullWidth>
                <DialogTitle>
                    {props.title}
                </DialogTitle>
                <DialogContent>
                    <Grid container direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                        {props.text &&
                            <Grid>
                                <DialogContentText> {props.text} </DialogContentText>
                            </Grid>
                        }
                        {props.searchable === true &&
                            <Grid>
                                <Autocomplete
                                    multiple
                                    id="tags-outlined"
                                    options={props.options}
                                    disableCloseOnSelect
                                    getOptionDisabled={(option) =>
                                        disableSelections
                                    }
                                    getOptionLabel={(option) => option}
                                    defaultValue={props.currentSelection}
                                    filterSelectedOptions
                                    onChange={(event: any, newValue: string[]) => { HandleSelect(newValue) }}
                                    style={{ minWidth: 500 }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={props.title}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option + Math.random()}>
                                            <span>{option}</span>
                                        </li>
                                    )}
                                />
                            </Grid>
                        }
                        {props.isAgentName &&
                            <FormGroup>
                                <FormControlLabel control={<Checkbox checked={activeAgentsFlag} onChange={activeAgentCheckboxHandler} />} label="Show inactive agents" />
                            </FormGroup>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={Close} color="primary">Cancel</Button>
                    <Button onClick={HandleConfirm} color="primary">Confirm</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}

